/* unplugin-vue-components disabled */import { render } from "./filters-calendar.vue?vue&type=template&id=3dc2bda2&scoped=true"
import script from "./filters-calendar.vue?vue&type=script&lang=js"
export * from "./filters-calendar.vue?vue&type=script&lang=js"

import "./filters-calendar.vue?vue&type=style&index=0&id=3dc2bda2&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dc2bda2"],['__file',"src/components/filters/filters-elements/filters-calendar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3dc2bda2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3dc2bda2', __exports__)) {
    api.reload('3dc2bda2', __exports__)
  }
  
  module.hot.accept("./filters-calendar.vue?vue&type=template&id=3dc2bda2&scoped=true", () => {
    api.rerender('3dc2bda2', render)
  })

}


export default __exports__